var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 9.33342H15.3337V8.00008C15.3337 6.16008 13.8403 4.66675 12.0003 4.66675C10.1603 4.66675 8.66699 6.16008 8.66699 8.00008V9.33342H8.00033C7.26699 9.33342 6.66699 9.93341 6.66699 10.6667V17.3334C6.66699 18.0667 7.26699 18.6667 8.00033 18.6667H16.0003C16.7337 18.6667 17.3337 18.0667 17.3337 17.3334V10.6667C17.3337 9.93341 16.7337 9.33342 16.0003 9.33342ZM12.0003 15.3334C11.267 15.3334 10.667 14.7334 10.667 14.0001C10.667 13.2667 11.267 12.6667 12.0003 12.6667C12.7337 12.6667 13.3337 13.2667 13.3337 14.0001C13.3337 14.7334 12.7337 15.3334 12.0003 15.3334ZM10.0003 9.33342V8.00008C10.0003 6.89341 10.8937 6.00008 12.0003 6.00008C13.107 6.00008 14.0003 6.89341 14.0003 8.00008V9.33342H10.0003Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d42c3b385290c4745b228d6086f368de.svg";
export { ForwardRef as ReactComponent };